"use client"

import React, { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { User } from "../types/Types" // #POW-35

import { useContext } from 'react'; // #POW-35
import { ThemeContext } from '../theme/AppTheme'; // #POW-35

const AuthContext = React.createContext<{
	token: string | null
	user: User,

	checkToken: () => Promise<boolean>
	onLogout: () => void
	onLogin: (username: string, password: string) => Promise<boolean>
	isReady: boolean
	setStorageData: (accessToken: string, userData: any) => void,
	canAccessContext: (context: string) => boolean, // #POW-22 
	setLocale: (locale:string) => void // #POW-35
}>({
	token: null,
	user: {
		locale: null,
		name: null,
		fullName: null,
		givenName: null,
		surname: null,
		email: null,
		entitlement: null,
		jobTitle: null,
		officeLocation: null,
		avatar: null,
	}, // #POW-35

	checkToken: async () => false,
	onLogout: () => { },
	onLogin: async (username: string, password: string) => false,
	isReady: false,
	setStorageData: (accessToken: string, userData: any) => { },
	canAccessContext: (context: string) => false, // #POW-22 ,
	setLocale: (locale:string) => {} // #POW-35
})

export const AuthContextProvider = ({
	children,
}: {
	children: React.ReactNode
}) => {



	const [token, setToken] = useState<string | null>(null)

	const [user, setUser] = React.useState<User>({
		locale: null,
		name: null,
		fullName: null,
		givenName: null,
		surname: null,
		email: null,
		entitlement: null,
		jobTitle: null,
		officeLocation: null,
		avatar: null,
	}) // #POW-35

	const [isReady, setIsReady] = useState<boolean>(false)
	const navigate = useNavigate()

	useEffect(() => {
		//console.log('AuthContextProvider', localStorage)
		const storedToken = localStorage.getItem("accessToken")
		const rawStoredUserData = localStorage.getItem("userData")
		const storedUserData = rawStoredUserData ? JSON.parse(rawStoredUserData) : null

		if (storedToken && storedUserData) {
			//console.log(' AuthContextProviderready!', storedToken , storedUserData)
			setToken(storedToken)

			const str_avatar = (storedUserData.givenName ? storedUserData.givenName[0] : "") + (storedUserData.surname ? storedUserData.surname[0] : "")
			setUser({
				locale: storedUserData.locale,
				name: storedUserData.name,
				fullName: storedUserData.name,
				givenName: storedUserData.givenName,
				surname: storedUserData.surname,
				email: storedUserData.email,
				entitlement: storedUserData.entitlement,
				jobTitle: storedUserData.jobTitle, // #POW-24
				officeLocation: storedUserData.officeLocation, // #POW-24
				avatar: str_avatar, // #POW-26
			}) // #POW-35

			setIsReady(true)
		} else {
			//console.log(' AuthContextProvidernot ready!')
			setIsReady(false)
			navigate("/")
		}
	}, [])

	const logoutHandler = () => {
		localStorage.removeItem("accessToken")
		localStorage.removeItem("userData")

		setToken(null)
		setUser({
			locale: null,
			name: null,
			fullName: null,
			givenName: null,
			surname: null,
			email: null,
			entitlement: null,
			jobTitle: null,
			officeLocation: null,
			avatar: null,
		}) // #POW-35
		setIsReady(false)
		

		navigate("/")
	}

	const loginHandler = async (username: string, password: string) => {
		// Not implemented
		return false
	}

	const checkToken = async () => {
		const accessToken = token || localStorage.getItem("accessToken")

		if (accessToken) {
			setToken(accessToken)
			return true
		}

		logoutHandler()
		return false
	}

	const setStorageData = (accessToken: string, userData: any) => {
		localStorage.setItem("accessToken", accessToken);
		setToken(accessToken);

		const str_avatar = (userData.givenName ? userData.givenName[0] : "") + (userData.surname ? userData.surname[0] : "")
		const obj = {
			locale: userData.locale,
			name: userData.name,
			fullName: userData.name,
			givenName: userData.givenName,
			surname: userData.surname,
			email: userData.email,
			entitlement: userData.entitlement,
			jobTitle: userData.graphJobTitle, // #POW-24
			officeLocation: userData.graphOfficeLocation, // #POW-24
			avatar: str_avatar, // #POW-26
		}
		setUser(obj) // #POW-35
		localStorage.setItem("userData", JSON.stringify(obj)); // SSO data + Worten entitlements
		
		setIsReady(true);
	}

	const setLocale = (locale: any) => {
		user.locale = locale;
		localStorage.setItem("userData", JSON.stringify(user)); // SSO data + Worten entitlements
	}

	/**
	 * #POW-22 > #POW-35
	 * Takes care to check for a specific user permission to access, manage ow whatever
	 * @param context 
	 * @returns 
	 */
	const canAccessContext = (context: string): boolean => {
		switch (context) {
			case 'pages.TransactionsCheckedInPage':
				return user.entitlement == 'logistic'

			case 'pages.TransactionsSentPage':
				return user.entitlement == 'shop'

			case 'pages.AllTransactionsPage': // #POW-80
				return user.entitlement == 'logistic'

			default:
				return false
		}
	}

	return (
		<AuthContext.Provider
			value={{
				token: token,
				user: user, // #POW-35

				checkToken: checkToken,
				onLogout: logoutHandler,
				onLogin: loginHandler,
				isReady: isReady,
				setStorageData: setStorageData,
				canAccessContext: canAccessContext, // #POW-22
				setLocale: setLocale
				
			}}
		>
			{children}
		</AuthContext.Provider>
	)
}

export default AuthContext
